import React, { FC, ReactNode } from 'react'
import { Box, Typography, TypographyTypeMap } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'

export interface IInsightsCardSubtitleProps {
  color?: TypographyTypeMap['props']['color']
  isLoading?: boolean
  skeletonWidth?: number | string
  text?: string | ReactNode
  tooltip?: string
  variant?: TypographyTypeMap['props']['variant']
  withBottomSpacing?: boolean
  withTopSpacing?: boolean
}

export const InsightsCardSubtitle: FC<IInsightsCardSubtitleProps> = ({
  isLoading = true,
  text,
  withBottomSpacing = false,
  withTopSpacing = false,
}) => {
  if (!text) {
    return null
  }

  return (
    <Typography variant='subtitle2' color='textSecondary'>
      {isLoading ? (
        <Box mb={withBottomSpacing ? 2 : 0} mt={withTopSpacing ? 0.5 : 0}>
          <Skeleton width={74} animation='wave' />
        </Box>
      ) : (
        <Box
          display='flex'
          component='span'
          mb={withBottomSpacing ? 2 : 0}
          mt={withTopSpacing ? 0.5 : 0}>
          {text}
        </Box>
      )}
    </Typography>
  )
}
